import { accountNav, homeNav, productMgntNav, systemNav } from "../../nav";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { loadAuth } from "../../../libs/authMgmt";
import GoogleAds from "../../ads/GoogleAd";
import React from "react";

export default function Header({ elementRef }) {
  // const [activeLink, setActiveLink] = useState("");
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  return (
    <>
      <nav className={"nest_nav"} ref={elementRef}>
        {/* <h2>Nest</h2> */}
        <img
          className="comp_header_logo"
          src={`${
            loadAuth("company")?.companyLogo === "default-logo.png"
              ? "/default-logo.png"
              : loadAuth("company")?.companyLogo
          }`}
          alt=""
          width="100px"
        />
        <div className="comp_default">
          <img src="/landing/nest_blue_bird.png" alt="" className="" />
        </div>

        <div
          className="nav_container"
          style={{
            height: "75vh",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            scrollbarColor: "#c1c1c1 transparent",
            msOverflowStyle: "none",
          }}
        >
          <ul>
            <span className={"nav-link-headers"}>Home</span>
            {homeNav?.map((data, i) => {
              const Icon = LucideIcons[data.icon];
              return (
                <li
                  key={i}
                  className={`${
                    window.location.pathname === data.link ||
                    (data.link === "/dashboard"
                      ? window.location.pathname === "/"
                      : false)
                      ? "active-link"
                      : ""
                  }`}
                >
                  <Link to={data.link} onClick={scrollToTop}>
                    <span>
                      {Icon &&
                        React.createElement(Icon, {
                          size: 42,
                          className: "icon-nav",
                        })}
                    </span>
                    <span className="nav-text">{data.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>

          <ul>
            <span className={"nav-link-headers"}>Product Management</span>
            {productMgntNav?.map((data, i) => {
              const Icon = LucideIcons[data.icon];
              return (
                <li
                  key={i}
                  className={`${
                    window.location.pathname === data.link
                      ? "active-link"
                      : window.location.pathname === data.link
                      ? "active-link"
                      : ""
                  }`}
                >
                  <Link to={data.link} onClick={scrollToTop}>
                    <span>
                      {Icon &&
                        React.createElement(Icon, {
                          size: 42,
                          className: "icon-nav",
                        })}
                    </span>
                    <span className="nav-text">{data.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
          {loadAuth("role") === "admin" ? (
            <ul>
              <span className={"nav-link-headers"}>Account Management</span>
              {accountNav?.map((data, i) => {
                const Icon = LucideIcons[data.icon];
                return (
                  <li
                    key={i}
                    className={`${
                      window.location.pathname === data.link
                        ? "active-link"
                        : " "
                    }`}
                  >
                    <Link to={data.link} onClick={scrollToTop}>
                      <span>
                        {Icon &&
                          React.createElement(Icon, {
                            size: 42,
                            className: "icon-nav",
                          })}
                      </span>
                      <span className="nav-text">{data.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : (
            ""
          )}

          <ul>
            <span className={"nav-link-headers"}>System</span>
            {systemNav?.map((data, i) => {
              const Icon = LucideIcons[data.icon];
              return (
                <li
                  key={i}
                  className={`${
                    window.location.pathname === data.link ? "active-link" : ""
                  }`}
                >
                  <Link to={data.link} onClick={scrollToTop}>
                    <span>
                      {Icon &&
                        React.createElement(Icon, {
                          size: 42,
                          className: "icon-nav",
                        })}
                    </span>
                    <span className="nav-text">{data.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
          {/* insert google ads here */}
          {/* <GoogleAds slot="2054330268" /> */}
        </div>
      </nav>
    </>
  );
}
